const routerPaths = {
  home: () => `/`,
  plantSettings: () => `/plant-settings`,
  batterySettings: () => `/battery-settings`,
  powerPlantSettings: () => `/power-plant-settings`,
  charts: () => `/charts`,
  error: () => `/error`,
  login: () => `/login`,
  demo: () => `/demo`,
};

export default routerPaths;
